import baseRoute from '../baseRoute';

export default `${baseRoute}/equipmentUtilization` as const;
